module.exports = __webpack_public_path__ + "static/img/logo.8adf056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/admin_login/logo.png
// module id = h/Ap
// module chunks = 5